<div class="container">
  <div class="info" (click)="action($event)">
    <span class="icon attachment-icon"></span>
    <span class="name">{{ attachment.name }} </span>
    <span class="size">{{ size }}</span>
    <span [class]="downloadIconClass()"></span>
  </div>
  <div [class]="barClass()"></div>
</div>
